import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { updateLineItemNotes } from '../../../../../../../../../store/orders/actions';
import { Input } from 'cat-ecommerce-alloy';
import styles from './LineItemNotesInput.module.scss';
import clsx from 'classnames';

const LineItemNotesInput = ({
  label,
  value,
  orderItemId,
  type,
  maxLength,
  datacsMask,
  errorMessage,
  onChange
}) => {
  const uniqueId = `${label}-${orderItemId}`;
  const dispatch = useDispatch();
  const { focusedInputNoteId } = useSelector(s => s.orders);

  useEffect(() => {
    if (focusedInputNoteId && document.getElementById(focusedInputNoteId)) {
      document.getElementById(focusedInputNoteId).focus();
    }
  }, [focusedInputNoteId]);

  const updateLineItemInput = e => {
    const inputValue = e.target.value;
    const focusedInputNoteId = e.relatedTarget?.id;
    if (value !== inputValue) {
      dispatch(
        updateLineItemNotes({
          type,
          input: inputValue,
          orderItemId,
          focusedInputNoteId
        })
      );
    }
  };

  return (
    <div
      className={clsx(`px-1 ${styles['line-item-notes__input']}`, {
        [`${styles['line-item-note-width']}`]: type === 'lineItemNote'
      })}
    >
      <Input
        placeholder={label}
        title={label}
        name={label}
        id={uniqueId}
        value={value}
        error={errorMessage}
        setError={() => {}}
        onChange={onChange}
        onBlur={updateLineItemInput}
        maxLength={maxLength}
        className={`${styles['line-item-notes__input-field']}`}
        formGroupClassname="form-group"
        data-cs-mask={datacsMask}
      />
    </div>
  );
};

LineItemNotesInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  orderItemId: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.string,
  datacsMask: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func
};

export default LineItemNotesInput;
